import { useEffect, useState, ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface Props {
  children: ReactNode
}

export const Portal = ({ children }: Props) => {
  const [el] = useState(() => document.createElement('div'))

  useEffect(() => {
    let mountPoint = document.getElementById('portal-root')

    if (!mountPoint) {
      const tempEl = document.createElement('div')
      tempEl.id = 'portal-root'
      document.body.append(tempEl)
      mountPoint = tempEl
    }

    mountPoint.appendChild(el)

    return () => {
      if (mountPoint) mountPoint.removeChild(el)
    }
  }, [el])

  return createPortal(children, el)
}
